import { useTranslation } from "react-i18next";
import { Loader } from "../Loader/Loader";
import { decodeSourceName } from "../../utils/decodeURI";
import { ReactComponent as VerifiedTwitter } from '../../pages/SourcePage/assets/verifiedTwitter.svg';
import { ReactComponent as ReturnIcon} from './assets/arrowLeft.svg';
import { ReactComponent as AddToIcon } from '../../assets/addTo.svg';
import { ReactComponent as SourceGroupIcon} from '../../pages/Layout/assets/database.svg';
import styles from '../../pages/SourcePage/SourcePage.module.scss';
import modalStyles from './WidgetContentModal.module.scss';
import { Link } from "react-router-dom";
import { Tooltip } from "react-tooltip";

export const ActorDetails = ({sourceData, children, onReturnClick, onAddToCase, onAddToGroup, showReturnButton = true, isShare = false}) => {
  const { t } = useTranslation();

  const makeAvatar = (sourceName) => {
    if (!sourceName) return '?';
    return sourceName.charAt(0).toUpperCase();
  };

  if (!sourceData) {
    return <Loader />;
  }

  return (
    <div className={modalStyles.actorDetailsContainer}>
      <div className={modalStyles.actorDetailsHeader}>
        {showReturnButton ? (
          <button className={modalStyles.returnButton} aria-label={t('Back to actors')} onClick={onReturnClick} data-tooltip-id="actor-details-return-tooltip" data-tooltip-content={t('Back to actors')}>
            <ReturnIcon />
          </button>
        ) : (
          <div style={{ width: '32px' }}></div>
        )}
        {!isShare && (
          <div className={modalStyles.actorDetailsActions}>
            <button
              className={modalStyles.saveButton}
              onClick={() => {
                onAddToGroup(true);
              }}
            >
              <SourceGroupIcon />
              {t('Add actors to group')}
            </button>
            <button
              className={modalStyles.saveButton}
              onClick={() => {
                onAddToCase(true);
              }}
            >
              <AddToIcon />
              {t('Add publications to case')}
            </button>

            <Link
              to={`/sources/${sourceData.id}`}
              target="_blank"
              rel="noopener noreferrer"
              className={modalStyles.actorDetails}
            >
              {t('View actor details')}
            </Link>
          </div>
        )}
        
      </div>
      <div className={styles.header} id='#top'>
        <div className={styles.avatarWrapper}>
          {/* <div className={styles.avatar}><img src={sourceData.avatar}></img></div> */}
          <div className={styles.avatar}>{makeAvatar(decodeSourceName(sourceData?.name))}</div>
        </div>
        <div className={styles.headerMain}>
          <div className={styles.headerName}>
            <span>{decodeSourceName(sourceData?.name)}</span>
            {sourceData?.is_verified ? (
              <span className={styles.verified}>
                <VerifiedTwitter/>
              </span>
            ) : (
              ''
            )}
          </div>
          <div className={styles.sourceLink}>
            <a href={sourceData?.url} target="_blank" rel="noopener noreferrer">{decodeSourceName(sourceData?.url)}</a>
          </div>
          <div className={styles.headerInfo}>
            <ul className={styles.headerList}>
              <li>
                <span>{t('Actor platform')}:</span> {sourceData?.source_type}
              </li>
              <li>
                <span> {t('Actor type')}:</span>
                {sourceData?.source_type === 'WEB' ? t('WEB') : t('Social media')}
              </li>
              <li>
                <span>{t('Actor origin country')}:</span>{sourceData?.origin_country ? sourceData.origin_country.name : t("N/A")}
              </li>
              <li>
                <span>{t('Actor main language')}:</span> {sourceData.language ? sourceData.language : t("N/A")}
              </li>
            </ul>
          </div>
        </div>
      </div>
      {children}
      <Tooltip id="actor-details-return-tooltip" />
    </div>
  );
};